import React from 'react';
import { Form, Input, Row, Col, Divider } from 'antd';

/**
 * One customer contact block (Organization Admin / Contract Admin / Billing
 * Contact). Handoff section 5: the three contacts must be clearly distinct and
 * must NOT be presented as VelorHR user accounts. `namePrefix` nests the fields
 * (e.g. name={['organizationAdmin','email']}).
 */
const ContactFields = ({ namePrefix, title, description }) => (
  <div>
    <Divider orientation="left" orientationMargin={0} style={{ borderColor: '#eaecf0' }}>
      {title}
    </Divider>
    {description ? (
      <p style={{ color: '#64748b', marginTop: -8, marginBottom: 12 }}>{description}</p>
    ) : null}
    <Row gutter={12}>
      <Col xs={24} md={8}>
        <Form.Item name={[namePrefix, 'firstName']} label="First name" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
      </Col>
      <Col xs={24} md={8}>
        <Form.Item name={[namePrefix, 'middleName']} label="Middle name">
          <Input />
        </Form.Item>
      </Col>
      <Col xs={24} md={8}>
        <Form.Item name={[namePrefix, 'lastName']} label="Last name" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
      </Col>
      <Col xs={24} md={12}>
        <Form.Item
          name={[namePrefix, 'email']}
          label="Email"
          rules={[{ required: true }, { type: 'email', message: 'Enter a valid email' }]}
        >
          <Input />
        </Form.Item>
      </Col>
      <Col xs={24} md={12}>
        <Form.Item name={[namePrefix, 'phone']} label="Phone" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
      </Col>
      <Col xs={24}>
        <Form.Item name={[namePrefix, 'address']} label="Address" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
      </Col>
    </Row>
  </div>
);

export default ContactFields;
